/* Zyara FR — offre « Kaching Bundles » reproduite sans l'app.
   Balisage d'origine conserve ; ce script gere la barre choisie, la taille de chaque article,
   le recalcul des prix (variantes Liquid) et l'ajout au panier du lot complet. */
(function () {
  'use strict';
  function money(cents) {
    var s = (Math.round(cents) / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return s[0] + ',' + s[1] + ' €';
  }
  function init(root) {
    var section = root.closest('section, .shopify-section') || document;
    var cfgEl = section.querySelector('script[data-tx-deal]');
    var varEl = section.querySelector('script[data-tx-variants]');
    if (!cfgEl || !varEl) return;
    var cfg = JSON.parse(cfgEl.textContent), variants = JSON.parse(varEl.textContent);
    var bars = [].slice.call(root.querySelectorAll('.kaching-bundles__bar'));
    function barCfg(bar) {
      var id = bar.getAttribute('data-deal-bar-id');
      return cfg.bars.filter(function (b) { return b.id === id; })[0] || { qty: 1, type: 'default', value: 0 };
    }
    function chosen(bar) {
      var bc = barCfg(bar), out = [];
      var sels = [].slice.call(bar.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper'));
      for (var i = 0; i < bc.qty; i++) {
        var w = sels[i] || sels[0], opts = [];
        if (w) [].slice.call(w.querySelectorAll('select')).forEach(function (s) { opts.push(s.value); });
        var v = variants.filter(function (x) { return opts.length ? x.options.join('|') === opts.join('|') : true; })[0] || variants[0];
        out.push(v);
      }
      return out;
    }
    function price(bar) {
      var bc = barCfg(bar), items = chosen(bar);
      var total = 0, full = 0;
      items.forEach(function (v) { total += v.price; full += (cfg.useCompare && v.compare_at_price) ? v.compare_at_price : v.price; });
      var disc = 0;
      if (bc.type === 'amount') disc = Math.round(bc.value * 100) * items.length;
      else if (bc.type === 'percentage') disc = Math.round(total * bc.value / 100);
      else if (bc.type === 'fixed') disc = total - Math.round(bc.value * 100);
      var p = total - disc;
      var pe = bar.querySelector('.kaching-bundles__bar-price'), fe = bar.querySelector('.kaching-bundles__bar-full-price');
      if (pe) pe.firstChild ? (pe.firstChild.nodeValue = money(p)) : (pe.textContent = money(p));
      if (fe) { fe.textContent = money(full); fe.style.display = full > p ? '' : 'none'; }
      var lb = bar.querySelector('.kaching-bundles__bar-label');
      if (lb) { lb.textContent = full > p ? 'ÉCONOMISEZ ' + money(full - p) : ''; lb.style.display = full > p ? '' : 'none'; }
      var st = bar.querySelector('.kaching-bundles__bar-subtitle');
      if (st && /\{\{\s*saved_total\s*\}\}/.test(bc.subtitle || '')) {
        st.textContent = bc.subtitle.replace(/\{\{\s*saved_total\s*\}\}/, money(full - p));
      }
    }
    function select(bar) {
      bars.forEach(function (b) { b.classList.toggle('kaching-bundles__bar--selected', b === bar); });
      var r = bar.querySelector('input[type=radio]'); if (r) r.checked = true;
    }
    bars.forEach(function (bar) {
      bar.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        select(bar);
      });
      [].slice.call(bar.querySelectorAll('select')).forEach(function (s) {
        s.addEventListener('change', function () { s.setAttribute('data-value', s.value); select(bar); price(bar); });
      });
      price(bar);
    });
    // ajout au panier : le lot entier, taille par taille
    var form = section.querySelector('form[action*="/cart/add"]');
    function addBundle(e) {
      var bar = root.querySelector('.kaching-bundles__bar--selected') || bars[0];
      if (!bar) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var counts = {};
      chosen(bar).forEach(function (v) { counts[v.id] = (counts[v.id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
      var btn = form && form.querySelector('[type=submit]'); if (btn) btn.setAttribute('aria-disabled', 'true');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (btn) btn.removeAttribute('aria-disabled');
          document.dispatchEvent(new CustomEvent('tx:cart:added', { detail: res }));
          // le tiroir (tx-kaching-cart.js) intercepte /cart/add et s'ouvre tout seul
          if (!window.txCart) location.href = '/cart';
        })
        .catch(function () { location.href = '/cart'; });
    }
    if (form) {
      form.addEventListener('submit', addBundle, true);
      var b = form.querySelector('[type=submit]');
      if (b) b.addEventListener('click', addBundle, true);
    }
  }
  function boot() { [].slice.call(document.querySelectorAll('[data-tx-kaching]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
